export default __webpack_public_path__ + "static/media/c(2).bc0fbbc4.jpg";